import { NgModule } from "@angular/core";
import { Routes, RouterModule, ExtraOptions } from "@angular/router";
import { AppBlankComponent } from "./layouts/blank/blank.component";
import { AppFullComponent } from "./layouts/full/full.component";
import { AuthGuard } from "./share/service/guard.service";
import { ComparisonGuard } from "./share/service/comparison-guard.service";
import { ComparisonComponent } from "./comparison/comparison.component";
import { UploadDocumentsComponent } from "./car-insurance/screens/upload-documents/upload-documents.component";
import { CompanyModule } from "./company/company.module";

import { EndorsementPaymentComponent } from "./endorsement/screens/endorsement-payment/endorsement-payment.component";
const routerOptions: ExtraOptions = {
	anchorScrolling: "enabled",
	scrollOffset: [0, 64]
};

const routes: Routes = [
	{
		path: "",
		canActivate: [AuthGuard],
		component: AppFullComponent,
		children: [
			// {
			// 	path: "",
			// 	redirectTo: "/transactions",
			// 	pathMatch: "full",
			// },
			{
				path: "transactions",
				loadChildren: () =>
					import("./transactions/transactions.module").then(
						(m) => m.TransactionsModule
					)
			},
			{
				path: "quotations",
				loadChildren: () =>
					import("./quotations/quotations.module").then(
						(m) => m.QuotationsModule
					)
			},
			{
				path: "user-management",
				loadChildren: () =>
					import("./user-management/user-management.module").then(
						(m) => m.UserManagementModule
					)
			},
			{
				path: "company",
				loadChildren: () =>
					import("./company/company.module").then((m) => m.CompanyModule)
			},
			{
				path: "u/comparison/:id",
				component: ComparisonComponent
			},
			{
				path: "",
				loadChildren: () =>
					import("./car-insurance/car-insurance.module").then(
						(m) => m.CarInsuranceModule
					)
			}
		]
	},
	{
		path: "",
		component: AppBlankComponent,
		children: [
			{
				path: "payment",
				loadChildren: () =>
					import("./payment/payment.module").then((m) => m.PaymentModule)
			},
			{
				path: "comparison/:id",
				component: ComparisonComponent,
				canActivate: [ComparisonGuard]
			},
			{
				path: "upload-documents/:id",
				component: UploadDocumentsComponent
			},
			{
				path: "",
				loadChildren: () =>
					import("./authentication/authentication.module").then(
						(m) => m.AuthenticationModule
					)
			},
			{
				path: "carsome",
				loadChildren: () =>
					import("./authentication/authentication.module").then(
						(m) => m.AuthenticationModule
					)
			},
			{
				path: "mg",
				loadChildren: () =>
					import("./authentication/authentication.module").then(
						(m) => m.AuthenticationModule
					)
			},
			{
				path: "fundingsocieties",
				loadChildren: () =>
					import("./authentication/authentication.module").then(
						(m) => m.AuthenticationModule
					)
			},
			{
				path: "imotorbike",
				loadChildren: () =>
					import("./authentication/authentication.module").then(
						(m) => m.AuthenticationModule
					)
			}
		]
	},
	{
		path: "endorsement-payment/:id",
		component: EndorsementPaymentComponent
	},
	{
		path: "**",
		redirectTo: "/404"
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			scrollPositionRestoration: "enabled",
			anchorScrolling: "enabled",
			scrollOffset: [0, 64]
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule {}
